import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {Link} from "react-router-dom";


class About extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <div className={`main`} style={{marginBottom: "300px"}}>
        <div className="about">
          <div className="container flex flex--wrap">
            <div className="about__img">
              <img src="/imgs/photo-2.jpg" alt=""/>
            </div>
            <div className="about__descr">
              <div className="title">
                <div className="h2">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.safetyforsexworkers")}
                </div>
              </div>
              {typeof window !== "undefined" &&
              <p style={{fontSize: '14px', lineHeight: '14px'}} dangerouslySetInnerHTML={{__html: this.props.MainContent}}></p>
              }
              <Link to="/signup" className="btn btn--blue">{wActs.getTranslation(this.props.WebPage.Translations,"page.header.signup")}</Link>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(About);
